/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

/* global _paq */
import VueMatomo from 'vue-matomo';
import Vue from "vue";
import {router} from "./vue-router";

export const matomoInitializer = {
    initMatomo
}

function initMatomo(matomoUrl, matomoSiteId) {
    Vue.use(VueMatomo, {
        host: matomoUrl,
        siteId: matomoSiteId,
        trackerFileName: "matomo",
        router: router,
        enableLinkTracking: true,
        requireConsent: false,
        trackInitialView: true,
        disableCookies: false,
        requireCookieConsent: false,
        enableHeartBeatTimer: false,
        heartBeatTimerInterval: 15,
        debug: false,
        userId: undefined,
        cookieDomain: undefined,
        domains: undefined,
        preInitActions: []
    });

    history.pushState = ( f => function pushState(){
        const ret = f.apply(this, arguments);
        window.dispatchEvent(new Event('pushstate'));
        window.dispatchEvent(new Event('locationchange'));
        return ret;
    })(history.pushState);

    history.replaceState = ( f => function replaceState(){
        const ret = f.apply(this, arguments);
        window.dispatchEvent(new Event('replacestate'));
        window.dispatchEvent(new Event('locationchange'));
        return ret;
    })(history.replaceState);

    window.addEventListener('popstate',()=>{
        window.dispatchEvent(new Event('locationchange'))
    });
    window.addEventListener('locationchange', function(){
        _paq.push(['setDocumentTitle', document.title]);
        //Track downloads
        _paq.push(['setDownloadExtensions']);
        //Track page views
        _paq.push(['trackPageView']);
        //Track page impressions
        _paq.push(['trackAllContentImpressions']);
        const currentUrl = location.href;
        _paq.push(['setReferrerUrl', currentUrl]);
        _paq.push(['setCustomUrl', currentUrl]);
        // remove all previously assigned custom variables, requires Matomo (formerly Piwik) 3.0.2
        _paq.push(['deleteCustomVariables', 'page']);
        // _paq.push(['setGenerationTimeMs', 0]);
        // make Matomo aware of newly added content
        const content = document.getElementById('app');
        _paq.push(['MediaAnalytics::scanForMedia', content]);
        _paq.push(['FormAnalytics::scanForForms', content]);
        _paq.push(['trackContentImpressionsWithinNode', content]);
    })
    //Fire up a new locationchange event to get the first page.
    window.dispatchEvent(new Event('locationchange'))
}

